module.exports = {
  colors: {
    'primary-color': '#4a67fb',
    'link-color': '#4a67fb',
    'success-color': '#24ed80',
    'warning-color': '#ffbb00',
    'error-color': '#ed2454',
    'font-size-base': '14px',
    'heading-color': 'rgba(0, 0, 0, 0.85)',
    'text-color': 'rgba(0, 0, 0, 0.65)',
    'text-color-secondary': 'rgba(0, 0, 0, 0.45)',
    'disabled-color': 'rgba(0, 0, 0, 0.25)',
    'border-radius-base': '4px',
    'border-color-base': '#d9d9d9',
    'box-shadow-base': '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
  ids: {
    styleScope: 'context-ui-pnid-style-scope',
  },
};
